var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkFlowEasyMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5077 0.532715H4.09083C2.36495 0.532715 0.96582 1.93184 0.96582 3.65772V28.6577C0.96582 30.3836 2.36495 31.7827 4.09083 31.7827H17.6326V29.6994H4.09083C3.51554 29.6994 3.04913 29.233 3.04913 28.6577V3.65772C3.04913 3.08242 3.51554 2.61602 4.09083 2.61602H39.5077C40.083 2.61602 40.5494 3.08242 40.5494 3.65772V22.4077H42.6327V3.65772C42.6327 1.93184 41.2335 0.532715 39.5077 0.532715Z",
    fill: "url(#paint0_linear_985_5087)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5491 30.7412H13.4658V36.9912H15.5491V30.7412Z",
    fill: "url(#paint1_linear_985_5087)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25758 25.5327C7.68229 25.5327 7.21588 25.0663 7.21588 24.491V22.4077H5.13257V24.491C5.13257 26.2169 6.53169 27.616 8.25758 27.616H10.3409V25.5327H8.25758Z",
    fill: "url(#paint2_linear_985_5087)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21588 18.2412H5.13257V20.3245H7.21588V18.2412Z",
    fill: "url(#paint3_linear_985_5087)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0357 22.5969C36.9131 20.4738 34.0338 19.2812 31.0317 19.2813C24.7811 19.2815 19.7142 24.3488 19.7144 30.5994C19.7146 36.85 24.782 41.9169 31.0326 41.9167C34.0337 41.9166 36.9119 40.7245 39.0343 38.6025C43.4545 34.1831 43.4552 27.0172 39.0357 22.5969ZM31.0263 39.8344C25.9263 39.8326 21.7933 35.6969 21.795 30.5969C21.7968 25.4969 25.9325 21.3639 31.0326 21.3656C33.4838 21.359 35.8357 22.3344 37.5628 24.0739C39.293 25.8062 40.2646 28.1547 40.2638 30.6031C40.2621 35.7031 36.1263 39.8361 31.0263 39.8344Z",
    fill: "url(#paint4_linear_985_5087)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6609 45.8455L44.1223 39.3091C43.927 39.1138 43.6621 39.0039 43.3859 39.0039C43.1096 39.004 42.8448 39.1138 42.6495 39.3091L39.7432 42.2153C39.3366 42.6221 39.3366 43.2814 39.7432 43.6883L46.2818 50.2278C46.4771 50.4232 46.7421 50.533 47.0182 50.533C47.2949 50.5321 47.5599 50.4212 47.7547 50.2247L50.6609 47.3185C51.0676 46.9116 51.0676 46.2522 50.6609 45.8455ZM47.0181 48.0185L41.9525 42.9518L43.3858 41.5185L48.4515 46.5852L47.0181 48.0185Z",
    fill: "url(#paint5_linear_985_5087)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0356 37.1289L37.5625 38.6021L41.1952 42.2348L42.6683 40.7617L39.0356 37.1289Z",
    fill: "url(#paint6_linear_985_5087)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1743 23.4492V25.5325C34.0494 25.5359 36.3792 27.8658 36.3826 30.7408H38.4659C38.4615 26.7157 35.1995 23.4538 31.1743 23.4492Z",
    fill: "url(#paint7_linear_985_5087)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7159 35.9492H11.3826V38.0325H19.7159V35.9492Z",
    fill: "url(#paint8_linear_985_5087)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5908 4.69922C14.8649 4.69922 13.4658 6.09834 13.4658 7.82422C13.4658 9.5501 14.8649 10.9492 16.5908 10.9492C18.3167 10.9492 19.7158 9.5501 19.7158 7.82422C19.7158 6.09834 18.3167 4.69922 16.5908 4.69922ZM16.5908 8.86582C16.0155 8.86582 15.5491 8.39941 15.5491 7.82412C15.5491 7.24883 16.0155 6.78242 16.5908 6.78242C17.1661 6.78242 17.6325 7.24883 17.6325 7.82412C17.6325 8.39951 17.1661 8.86582 16.5908 8.86582Z",
    fill: "url(#paint9_linear_985_5087)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8826 11.9912C22.1567 11.9912 20.7576 13.3903 20.7576 15.1162C20.7576 16.8421 22.1567 18.2412 23.8826 18.2412C25.6085 18.2412 27.0076 16.8421 27.0076 15.1162C27.0076 13.3903 25.6085 11.9912 23.8826 11.9912ZM23.8826 16.1579C23.3073 16.1579 22.8409 15.6915 22.8409 15.1162C22.8409 14.5409 23.3073 14.0745 23.8826 14.0745C24.4579 14.0745 24.9243 14.5409 24.9243 15.1162C24.9242 15.6915 24.4579 16.1579 23.8826 16.1579Z",
    fill: "url(#paint10_linear_985_5087)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 8.13014L9.60425 13.3384L11.0774 14.8115L16.2856 9.60325L14.8125 8.13014Z",
    fill: "url(#paint11_linear_985_5087)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3645 8.13286L16.8914 9.60596L22.0996 14.8142L23.5727 13.3411L18.3645 8.13286Z",
    fill: "url(#paint12_linear_985_5087)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1743 4.69922C29.4484 4.69922 28.0493 6.09834 28.0493 7.82422C28.0493 9.5501 29.4484 10.9492 31.1743 10.9492C32.9002 10.9492 34.2993 9.5501 34.2993 7.82422C34.2994 6.09834 32.9003 4.69922 31.1743 4.69922ZM31.1743 8.86582C30.599 8.86582 30.1326 8.39941 30.1326 7.82412C30.1326 7.24883 30.599 6.78242 31.1743 6.78242C31.7496 6.78242 32.216 7.24883 32.216 7.82412C32.216 8.39951 31.7496 8.86582 31.1743 8.86582Z",
    fill: "url(#paint13_linear_985_5087)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3953 8.13356L24.187 13.3418L25.6601 14.8149L30.8684 9.60666L29.3953 8.13356Z",
    fill: "url(#paint14_linear_985_5087)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_5087",
    x1: 21.7992,
    y1: 0.532715,
    x2: 21.7992,
    y2: 31.7827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_985_5087",
    x1: 14.5075,
    y1: 30.7412,
    x2: 14.5075,
    y2: 36.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_985_5087",
    x1: 7.73673,
    y1: 22.4077,
    x2: 7.73673,
    y2: 27.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_985_5087",
    x1: 6.17422,
    y1: 18.2412,
    x2: 6.17422,
    y2: 20.3245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_985_5087",
    x1: 31.0321,
    y1: 19.2812,
    x2: 31.0321,
    y2: 41.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_985_5087",
    x1: 45.2021,
    y1: 39.0039,
    x2: 45.2021,
    y2: 50.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_985_5087",
    x1: 38.2991,
    y1: 37.8655,
    x2: 41.9318,
    y2: 41.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_985_5087",
    x1: 34.8201,
    y1: 23.4492,
    x2: 34.8201,
    y2: 30.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_985_5087",
    x1: 15.5492,
    y1: 35.9492,
    x2: 15.5492,
    y2: 38.0325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_985_5087",
    x1: 16.5908,
    y1: 4.69922,
    x2: 16.5908,
    y2: 10.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_985_5087",
    x1: 23.8826,
    y1: 11.9912,
    x2: 23.8826,
    y2: 18.2412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_985_5087",
    x1: 12.2084,
    y1: 10.7343,
    x2: 13.6815,
    y2: 12.2074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_985_5087",
    x1: 17.6279,
    y1: 8.86941,
    x2: 22.8361,
    y2: 14.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_985_5087",
    x1: 31.1743,
    y1: 4.69922,
    x2: 31.1743,
    y2: 10.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_985_5087",
    x1: 26.7911,
    y1: 10.7377,
    x2: 28.2642,
    y2: 12.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlowEasyMonitoring);
export default __webpack_public_path__ + "static/media/WorkFlow_EasyMonitoring.576dd09104ccce46754152d24231db8f.svg";
export { ForwardRef as ReactComponent };